import { defineMessages } from "react-intl";

import Button from "../Buttons/Button";
import { useFormatMessage } from "../Intl/Context";

// This component renders the recorder control buttons.
const SpeechToTextRecorderControls = ({ isPaused, onPauseToggle, onRestart, onSend }) => {
  const t = useFormatMessage();
  const sendLabel = t(intlMessages.sendLabel);
  const pauseLabel = t(intlMessages.pauseLabel);
  const resumeLabel = t(intlMessages.resumeLabel);
  const restartLabel = t(intlMessages.restartLabel);
  const pauseActionLabel = isPaused ? resumeLabel : pauseLabel;
  const actionButtonClassName = "btn btn-sm speech-to-text-recorder__action-button";
  const restartButtonClassName = `${actionButtonClassName} btn-danger`;
  const pauseButtonClassName = `${actionButtonClassName} btn-default`;
  const sendButtonClassName = `${actionButtonClassName} btn-success`;
  const pauseActionIconClassName = isPaused ? "fa fa-play" : "fa fa-pause";

  return (
    <div className="speech-to-text-recorder__actions">
      <Button
        type="button"
        className={restartButtonClassName}
        onClick={onRestart}
        aria-label={restartLabel}
        iconClassName="fa fa-rotate-left"
        label={restartLabel}
        hideLabelOnMobile
      />

      <Button
        type="button"
        className={pauseButtonClassName}
        onClick={onPauseToggle}
        aria-label={pauseActionLabel}
        iconClassName={pauseActionIconClassName}
        label={pauseActionLabel}
        hideLabelOnMobile
      />

      <Button
        type="button"
        className={sendButtonClassName}
        onClick={onSend}
        aria-label={sendLabel}
        iconClassName="fa fa-check"
        label={sendLabel}
        hideLabelOnMobile
      />
    </div>
  );
};

export default SpeechToTextRecorderControls;

const intlMessages = defineMessages({
  sendLabel: {
    id: "speechToTextRecorder.sendLabel",
    defaultMessage: "Terminer l'enregistrement"
  },
  pauseLabel: {
    id: "speechToTextRecorder.pauseLabel",
    defaultMessage: "Pause"
  },
  resumeLabel: {
    id: "speechToTextRecorder.resumeLabel",
    defaultMessage: "Reprendre"
  },
  restartLabel: {
    id: "speechToTextRecorder.restartLabel",
    defaultMessage: "Recommencer"
  }
});
